import React from 'react';

import { EColor } from '../Theme';

export const EmailIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 9L9.5 12L14 9"
      stroke={EColor.Black}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M17 19H3C1.89543 19 1 18.1046 1 17V7C1 5.89543 1.89543 5 3 5H16C17.1046 5 18 5.89543 18 7V9"
      stroke={EColor.Black}
      strokeLinecap="round"
      strokeWidth="2"
    />
    <path
      d="M17 14H23M23 14L20 11M23 14L20 17"
      stroke={EColor.Black}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
